import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './components/auth/LoginPage';
import DashboardPage from './components/dashboard/DashboardPage';
import AntraegePage from './components/antraege/AntraegePage';
import FoerdergeberPage from './components/foerdergeber/FoerdergeberPage';
import ProjektePage from './components/projekte/ProjektePage';
import ProjektDetailPage from './components/projekte/ProjektDetailPage';
import FinanzenProjektAuswahl from './components/finanzen/FinanzenProjektAuswahl';
import FinanzenPage from './components/finanzen/FinanzenPage';
import SachberichtProjektAuswahl from './components/sachberichte/SachberichtProjektAuswahl';
import SachberichtePage from './components/sachberichte/SachberichtePage';
import SachberichtDetailPage from './components/sachberichte/SachberichtDetailPage';
import VeranstaltungenProjektAuswahl from './components/veranstaltungen/VeranstaltungenProjektAuswahl';
import VeranstaltungenPage from './components/veranstaltungen/VeranstaltungenPage';
import VeranstaltungDetailPage from './components/veranstaltungen/VeranstaltungDetailPage';
import DokumenteProjektAuswahl from './components/dokumente/DokumenteProjektAuswahl';
import DokumentePage from './components/dokumente/DokumentePage';

const theme = createTheme({
  palette: {
    primary: { main: '#1B5E20' },
    secondary: { main: '#2E7D32' },
  },
  typography: { fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif' },
});

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<DashboardPage />} />
              <Route path="antraege" element={<AntraegePage />} />
              <Route path="foerdergeber" element={<FoerdergeberPage />} />
              <Route path="projekte" element={<ProjektePage />} />
              <Route path="projekte/:id" element={<ProjektDetailPage />} />
              <Route path="finanzen" element={<FinanzenProjektAuswahl />} />
              <Route path="finanzen/:projektId" element={<FinanzenPage />} />
              <Route path="sachberichte" element={<SachberichtProjektAuswahl />} />
              <Route path="sachberichte/:projektId" element={<SachberichtePage />} />
              <Route path="sachberichte/:projektId/:berichtId" element={<SachberichtDetailPage />} />
              <Route path="veranstaltungen" element={<VeranstaltungenProjektAuswahl />} />
              <Route path="veranstaltungen/:projektId" element={<VeranstaltungenPage />} />
              <Route path="veranstaltungen/:projektId/:veranstaltungId" element={<VeranstaltungDetailPage />} />
              <Route path="dokumente" element={<DokumenteProjektAuswahl />} />
              <Route path="dokumente/:projektId" element={<DokumentePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
